export const nl = {
    REQUIRED_ACTION_KeepCapturing: 'Blijf vastleggen.',
    REQUIRED_ACTION_PauseCapturing: 'Pauze Opname',
    REQUIRED_ACTION_Close: 'Dichtbij',
    REQUIRED_ACTION_Error: 'Fout',
    REQUIRED_ACTION_AGREE: 'Akkoord',
    REQUIRED_ACTION_DISAGREE: 'Niet mee eens',
    LIVENESS_ACTION_Smile: 'Glimlach',
    LIVENESS_ACTION_Frown: 'Fronsen',
    'LIVENESS_ACTION_Tilt Left': 'Kijk naar links.',
    'LIVENESS_ACTION_Tilt Right': 'Kijk naar rechts.',
    'LIVENESS_ACTION_Tilt Up': 'Kijk omhoog',
    'LIVENESS_ACTION_Tilt Down': 'Kijk naar beneden.',
    'LIVENESS_ACTION_Look Straight': 'Kijk recht vooruit.',
    'LIVENESS_ACTION_No Action': 'Geen actie',
    LIVENESS_ACTION_PROCESSING_LIVENESS: 'Verwerking Levendigheid',
    'LIVENESS_RESULT_Thank you!.Failed': 'Mislukt',
    'LIVENESS_RESULT_Thank you!.Passed': 'Geslaagd',
    'LIVENESS_RESULT_Thank you!.ActionTimedOut': 'Actie is verlopen',
    'LIVENESS_RESULT_Thank you!.Interrupted': 'Onderbroken',
    'LIVENESS_RESULT_Thank you!.Undefined': 'Ongedefinieerd',
    LIVENESS_ACTION_LOOK_STRAIGHT_TITLE: 'Kijk recht vooruit',
    LIVENESS_ACTION_LOOK_STRAIGHT_TEXT:
        'Houd je ogen altijd op het scherm gericht',
    LIVENESS_ACTION_LOOK_LEFT_TITLE: 'Draai je hoofd iets naar links',
    LIVENESS_ACTION_LOOK_LEFT_TEXT: 'Houd uw ogen altijd op het scherm gericht',
    LIVENESS_ACTION_LOOK_RIGHT_TITLE: 'Draai uw hoofd iets naar rechts',
    LIVENESS_ACTION_LOOK_RIGHT_TEXT:
        'Houd uw ogen altijd op het scherm gericht',
    LIVENESS_ACTION_LOOK_UP_TITLE: 'Draai uw hoofd iets omhoog',
    LIVENESS_ACTION_LOOK_UP_TEXT: 'Houd uw ogen altijd op het scherm gericht',
    LIVENESS_ACTION_LOOK_DOWN_TITLE: 'Draai uw hoofd iets naar beneden',
    LIVENESS_ACTION_LOOK_DOWN_TEXT: 'Houd uw ogen altijd op het scherm gericht',
    LIVENESS_ACTION_SMILE_TITLE: 'Glimlach',
    LIVENESS_ACTION_SMILE_TEXT: 'Houd uw ogen altijd op het scherm gericht',
    LIVENESS_ACTION_FROWN_TITLE: 'Frons',
    LIVENESS_ACTION_FROWN_TEXT:
        'Houd je ogen te allen tijde op het scherm gericht',
    PASSIVE_LIVENESS_ERROR_FACE_TOO_CLOSE_TITLE: 'Uh Oh...Je bent te dichtbij.',
    PASSIVE_LIVENESS_ERROR_FACE_CLOSE_TO_BORDER_TITLE:
        'Uh Oh...Je bent te dichtbij.',
    PASSIVE_LIVENESS_ERROR_FACE_CROPPED_TITLE:
        'Er is iets misgegaan. Probeer het opnieuw.',
    PASSIVE_LIVENESS_ERROR_FACE_CROPPED:
        'Er is iets misgegaan. Probeer het opnieuw.',
    PASSIVE_LIVENESS_ERROR_FACE_NOT_FOUND_TITLE:
        'We kunnen geen gezicht detecteren binnen de afbeelding. Probeer het opnieuw.',
    PASSIVE_LIVENESS_ERROR_FACE_TOO_SMALL_TITLE: 'Uh Oh...Je bent te ver weg.',
    PASSIVE_LIVENESS_ERROR_FACE_ANGLE_TOO_LARGE_TITLE:
        'Uh Oh...Er is iets misgegaan.',
    ASSIVE_LIVENESS_ERROR_FACE_ANGLE_TOO_LARGE:
        'Er is iets misgegaan. Probeer het opnieuw.',
    PASSIVE_LIVENESS_ERROR_TOO_MANY_FACES:
        'We kunnen geen gezicht detecteren in de afbeelding. Probeer het opnieuw.',
    PASSIVE_LIVENESS_ERROR_FACE_IS_OCCLUDED_TITLE:
        'Oei... We kunnen geen gezicht detecteren.',
    PASSIVE_LIVENESS_ERROR_UNKNOWN_TITLE: 'Oei... Er is iets misgegaan.',
    PASSIVE_LIVENESS_ERROR_UNKNOWN:
        'Er is iets misgegaan. Probeer het opnieuw.',
    PASSIVE_LIVENESS_ERROR_INTERNAL_TITLE: 'Oei... Er is iets misgegaan.',
    PASSIVE_LIVENESS_ERROR_INTERNAL:
        'Er is iets misgegaan. Probeer het opnieuw.',
    PASSIVE_LIVENESS_ERROR_LOW_THRESHOLD_TITLE: 'Oei... Er is iets misgegaan.',
    PASSIVE_LIVENESS_ERROR_LOW_THRESHOLD:
        'Er is iets misgegaan. Probeer het opnieuw.',
    PASSIVE_LIVENESS_ERROR_None_TITLE: 'Oei... Er is iets misgegaan.',
    PASSIVE_LIVENESS_ERROR_None: 'Er is iets misgegaan. Probeer het opnieuw.',
    PASSIVE_LIVENESS_ERROR_FailedExpressions_TITLE:
        'Oei... Er is iets misgegaan.',
    PASSIVE_LIVENESS_ERROR_FailedExpressions:
        'Er is iets misgegaan. Probeer het opnieuw.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_IMAGE_TITLE:
        'Oei... Er is iets misgegaan.',
    PASSIVE_LIVENESS_ERROR_IMAGE_ERROR_TITLE: 'Oei...Er is iets misgegaan.',
    PASSIVE_LIVENESS_ERROR_IMAGE_ERROR:
        'Er is iets fout gegaan. Probeer het opnieuw.',
    PASSIVE_LIVENESS_ERROR_INTERNAL_ERROR_TITLE: 'Oei...Er is iets misgegaan.',
    PASSIVE_LIVENESS_ERROR_INTERNAL_ERROR:
        'Er is iets fout gegaan. Probeer het opnieuw.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_WRITE_IMAGE_TITLE:
        'Oei...Er is iets misgegaan.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_WRITE_IMAGE:
        'Er is iets fout gegaan. Probeer het opnieuw.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_MODEL_TITLE:
        'Oei...Er is iets misgegaan.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_MODEL:
        'Er is iets fout gegaan. Probeer het opnieuw.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_ALLOCATE_TITLE:
        'Oei...Er is iets misgegaan.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_ALLOCATE:
        'Er is iets fout gegaan. Probeer het opnieuw.',
    PASSIVE_LIVENESS_ERROR_INVALID_CONFIG_TITLE: 'Oei...Er is iets misgegaan.',
    PASSIVE_LIVENESS_ERROR_INVALID_CONFIG:
        'Er is iets fout gegaan. Probeer het opnieuw.',
    PASSIVE_LIVENESS_ERROR_NO_SUCH_OBJECT_IN_BUILD_TITLE:
        'Oei...Er is iets misgegaan.',
    PASSIVE_LIVENESS_ERROR_NO_SUCH_OBJECT_IN_BUILD:
        'Er is iets fout gegaan. Probeer het opnieuw.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_PREDICT_TITLE:
        'Oei...Er is iets misgegaan.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_PREDICT:
        'Er is iets fout gegaan. Probeer het opnieuw.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_DETECT_TITLE:
        'Oei...Er is iets misgegaan.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_DETECT:
        'Er is iets fout gegaan. Probeer het opnieuw.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREDICT_LANDMARKS_TITLE:
        'Oei...Er is iets misgegaan.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREDICT_LANDMARKS:
        'Er is iets fout gegaan. Probeer het opnieuw.',
    PASSIVE_LIVENESS_ERROR_INVALID_FUSE_MODE_TITLE:
        'Oei...Er is iets misgegaan.',
    PASSIVE_LIVENESS_ERROR_INVALID_FUSE_MODE:
        'Er is iets fout gegaan. Probeer het opnieuw.',
    PASSIVE_LIVENESS_ERROR_NULLPTR_TITLE: 'Oei...Er is iets misgegaan.',
    PASSIVE_LIVENESS_ERROR_NULLPTR:
        'Er is iets fout gegaan. Probeer het opnieuw.',
    PASSIVE_LIVENESS_ERROR_LICENSE_ERROR_TITLE: 'Oei...Er is iets misgegaan.',
    PASSIVE_LIVENESS_ERROR_LICENSE_ERROR:
        'Er is iets fout gegaan. Probeer het opnieuw.',
    PASSIVE_LIVENESS_ERROR_INVALID_META_TITLE: 'Oei...Er is iets misgegaan.',
    PASSIVE_LIVENESS_ERROR_INVALID_META:
        'Er is iets fout gegaan. Probeer het opnieuw.',
    INITIALIZING_TITLE: 'Initialiseren',
    INITIALIZING_DESCRIPTION:
        'Controleren van hardware mogelijkheden, even geduld a.u.b...',
    JOURNEY_STATE_STARTED: 'Begonnen',
    JOURNEY_STATE_INPROGRESS: 'Bezig',
    JOURNEY_STATE_ENDED: 'Eindigde',
    INFO_JOURNEY_STATE: 'Staat',
    INFO_JOURNEY_ACTION: 'Actie',
    INFO_JOURNEY_ACTION_ATTEMPT: 'Poging tot actie',
    INFO_JOURNEY_ID: 'Reis-ID',
    INFO_JOURNEY_RESULT: 'Result',
    RESULTS_HIGH_LEVEL_EXPIRED_MESSAGE: 'Resultaatbericht',
    RESULTS_HIGH_LEVEL_EXPIRED_MESSAGE_VALUE:
        'De id die u ons gaf was verouderd - probeer iets anders',
    INFO_JOURNEY_REFERENCE: 'Referentie',
    FLOW_STATE_NONE: 'Geen',
    'FLOW_STATE_IDENTITY:FRONT': 'Voorzijde',
    'FLOW_STATE_IDENTITY:BACK': 'Achterkant',
    FLOW_STATE_ADDRESS: 'Adres',
    FLOW_STATE_SELFIE: 'zelfportret',
    FLOW_STATE_LIVENESS: 'Levendigheid',
    FLOW_STATE_COVID: 'Covid',
    PROVIDER_TITLE_CAMERA: 'Camera',
    PROVIDER_TITLE_CROPPER: 'Snijder',
    PROVIDER_TITLE_FILESYSTEM_ID: 'Upload een foto van uw identiteitsbewijs',
    PROVIDER_TITLE_FILESYSTEM_FACEMATCH: 'Upload een foto van uzelf',
    PROVIDER_TITLE_FILESYSTEM_ADDRESS: 'Upload een foto van uw adresbewijs',
    PROVIDER_TITLE_FILESYSTEM_COVID: 'Upload een foto van uw Covid-document',
    PROVIDER_TITLE_GATEWAY: 'Toegangspoort',
    PROVIDER_TITLE_LIVENESS: 'Levendigheid',
    PROVIDER_TITLE_LOGIN: 'Inloggen',
    PROVIDER_TITLE_RESULTS: 'Resultaten',
    PROVIDER_TITLE_SCANNER: 'Scan uw identiteitsbewijs',
    PROVIDER_TITLE_VIEW_ID: 'Controleer de preview van uw identiteitsbewijs',
    PROVIDER_TITLE_VIEW_FACEMATCH: 'Controleer de preview van uw selfie',
    PROVIDER_TITLE_VIEW_ADDRESS: 'Controleer de preview van uw adresbewijs',
    ROVIDER_TITLE_VIEW_COVID: 'Controleer de preview van uw Covid',
    PROVIDER_SUBTITLE_FILESYSTEM_ID:
        'Upload een foto van uw identiteitsbewijs die duidelijk, scherp, niet bedekt en direct face-on is.',
    PROVIDER_SUBTITLE_FILESYSTEM_FACEMATCH:
        'Upload een foto van uzelf die duidelijk, scherp, niet bedekt en direct face-on is',
    PROVIDER_SUBTITLE_FILESYSTEM_ADDRESS:
        'Upload een foto van uw document die duidelijk, scherp, niet bedekt en direct face-on is.',
    PROVIDER_SUBTITLE_FILESYSTEM_COVID:
        'Upload een foto van uw document die duidelijk, scherp, niet bedekt en direct face-on is.',
    PROVIDER_SUBTITLE_SCANNER_ID:
        'Leg de fotopagina van uw identiteitsbewijs met de bedrukte zijde naar beneden op de scanner.',
    PROVIDER_SUBTITLE_VIEW_ID:
        'Controleer of de preview van uw document duidelijk, scherp, niet bedekt en direct face-on is.',
    PROVIDER_SUBTITLE_VIEW_FACEMATCH:
        'Controleer of de preview van uw selfie duidelijk, scherp, niet bedekt en direct face-on is.',
    PROVIDER_SUBTITLE_VIEW_ADDRESS:
        'Controleer of de preview van uw document duidelijk, scherp, niet bedekt en direct face-on is.',
    PROVIDER_SUBTITLE_VIEW_COVID:
        'Controleer of de preview van uw document duidelijk, scherp, niet bedekt en direct face-on is.',
    PROVIDER_TITLE_SMART_CAPTURE: 'Slimme Vangst',
    PROVIDER_TITLE_JOURNEY_SELECT: 'Selecteer reis',
    PROVIDER_TITLE_TERMS_AND_CONDITIONS: 'Algemene voorwaarden',
    PROVIDER_TITLE_USER_INPUT: 'Vul het volgende formulier in',
    FILESYSTEM_SUPPORTED_TYPES_FIRST: 'Geaccepteerde formaten:',
    FILESYSTEM_SUPPORTED_TYPES_LIST: 'JPG, PNG',
    FILESYSTEM_SUPPORTED_TYPES_START_SELFIE: 'Geaccepteerde formaten: JPG, PNG',
    FILESYSTEM_MAX_FILE_SIZE:
        'Bestandsgrootte: we accepteren alle bestandsgroottes kleiner dan',
    FILESYSTEM_MAX_FILE_SIZE_NUMBER: '7,5 MB',
    FILESYSTEM_CHECK_FILE_TOO_BIG:
        'Uw bestand is te groot. Upload een bestand dat kleiner is dan 7,5 MB.',
    FILESYSTEM_CHECK_FILE_INCORRECT_FORMAT:
        'Uw bestand heeft het verkeerde formaat. Upload een van de geaccepteerde formaten.',
    FILESYSTEM_IDENTITY_DOCUMENT: 'Identiteitsbewijs',
    FILESYSTEM_FACEMATCH: 'Gezichtsmatch',
    FILESYSTEM_ADDRESS: 'Adresbewijs',
    FILESYSTEM_COVID: 'Covid',
    FILESYSTEM_DRAG_DROP: 'Slepen en neerzetten',
    FILESYSTEM_OR: 'of',
    FILESYSTEM_CHOOSE: 'Kies een bestand',
    FILESYSTEM_UPLOADING: 'Uploaden...',
    TRIPLESCAN_GUIDANCE_TRYAGAIN: 'Probeer het opnieuw',
    FAILURE_REASON_REFER: 'Uw identiteitsbewijs is niet gevalideerd.',
    FAILURE_REASON_EXPIRED: 'Uw identiteitsbewijs is verlopen.',
    FAILURE_REASON_NOT_ACCEPTED:
        'Uw identiteitsbewijs is geen geaccepteerd documenttype.',
    FAILURE_REASON_NOT_SUPPORTED:
        'Uw identiteitsbewijs kon niet worden geclassificeerd of wordt niet ondersteund.',
    PLEASE_TRY_AGAIN_REFER: 'Probeer het opnieuw.',
    PLEASE_TRY_AGAIN_EXPIRED: 'Probeer het opnieuw met een geldig document.',
    PLEASE_TRY_AGAIN_NOT_ACCEPTED:
        'Probeer het opnieuw met een ander document.',
    PLEASE_TRY_AGAIN_NOT_SUPPORTED: 'Probeer het opnieuw.',
    BLUR_CHECK_REASON: 'Onscherp - het document is onduidelijk;',
    GLARE_CHECK_REASON:
        'Schittering - het document is onleesbaar vanwege een felle lichtbron;',
    RESOLUTION_CHECK_REASON:
        'Lage resolutie - het document vult het frame niet goed;',
    EDGES_CHECK_REASON:
        'Ontbrekende randen - het document is niet goed in het frame geplaatst;',
    VALIDATION_FAILED: 'Validatie mislukt',
    VALIDATION_FAILED_REASON_DOC_UNKNOWN: '- document onbekend.',
    VALIDATION_FAILED_REASON_DOC_NOT_ACCEPTED: '- document niet geaccepteerd.',
    VALIDATION_FAILED_REASON_DOC_EXPIRED: '- document verlopen.',
    PREVIEW_INFO_TITLE_ID: "Voorbeelden van goede en slechte foto's",
    PREVIEW_INFO_GOOD: 'Goed',
    PREVIEW_INFO_BAD: 'Slecht',
    PREVIEW_INFO_GOOD_EXAMPLE_ID:
        'Foto is duidelijk, scherp en direct van voren.',
    PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ID: 'Foto moet alle vier de hoeken tonen.',
    PREVIEW_INFO_BAD_EXAMPLE_COVER_ID: 'Document mag niet bedekt zijn.',
    PREVIEW_INFO_BAD_EXAMPLE_BLUR_ID: 'Foto mag niet wazig zijn.',
    PREVIEW_INFO_TITLE_FACEMATCH: 'Tips voor een selfie van goede kwaliteit',
    PREVIEW_INFO_GOOD_EXAMPLE_FACEMATCH:
        'De selfie is duidelijk, scherp en direct op het gezicht gericht.',
    PREVIEW_INFO_BAD_EXAMPLE_ANGLE_FACEMATCH:
        'De selfie moet het hele gezicht tonen.',
    PREVIEW_INFO_BAD_EXAMPLE_COVER_FACEMATCH:
        'Het gezicht mag niet bedekt zijn.',
    PREVIEW_INFO_BAD_EXAMPLE_BLUR_FACEMATCH: 'De selfie mag niet wazig zijn.',
    PREVIEW_INFO_TITLE_ADDRESS: 'Tips voor een foto van goede kwaliteit',
    PREVIEW_INFO_GOOD_EXAMPLE_ADDRESS:
        'De foto is duidelijk, scherp en direct op het gezicht gericht.',
    PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ADDRESS:
        'De foto moet alle vier de hoeken tonen.',
    PREVIEW_INFO_BAD_EXAMPLE_COVER_ADDRESS:
        'Het document mag niet bedekt zijn.',
    PREVIEW_INFO_BAD_EXAMPLE_BLUR_ADDRESS: 'De foto mag niet wazig zijn.',
    PREVIEW_INFO_TITLE_COVID: 'Tips voor een foto van goede kwaliteit',
    PREVIEW_INFO_GOOD_EXAMPLE_COVID:
        'De foto is helder, scherp en direct van voren.',
    PREVIEW_INFO_BAD_EXAMPLE_ANGLE_COVID:
        'De foto moet alle vier de hoeken tonen.',
    PREVIEW_INFO_BAD_EXAMPLE_COVER_COVID: 'Het document mag niet bedekt zijn.',
    PREVIEW_INFO_BAD_EXAMPLE_BLUR_COVID: 'De foto mag niet wazig zijn.',
    ATTEMPTS_REMAINING: 'Aantal resterende pogingen:',
    CAMERA_CAPTURE: 'Camera inschakelen',
    CAMERA_CAPTURE_START_BUTTON: 'Automatisch vastleggen starten',
    CAMERA_CAPTURE_CAPTION:
        'Klik op Automatisch vastleggen starten om te beginnen',
    CAMERA_PREVIEW_START:
        'Schakel uw camera in om Automatisch vastleggen te starten',
    CAMERA_CONDITION_BLUR: 'Onscherpte gedetecteerd',
    CAMERA_CONDITION_CAPTURING: 'Vastleggen',
    CAMERA_CONDITION_UPLOADING: 'Uploaden...Even geduld',
    CAMERA_CONDITION_ALIGNMENT: 'Document niet in beeld',
    CAMERA_CONDITION_GLARE: 'Schittering gedetecteerd',
    VERIFYING_TITLE: 'Verifiëren ...',
    PREPARING_PREVIEW_TITLE: 'Voorvertoning voorbereiden ...',
    CAMERA_CONDITION_LOW_RESOLUTION: 'Document te ver',
    CAMERA_LOADING: 'Camera openen...',
    CAMERA_SMARTCAPTURE_ON: 'AUTOMATISCHE VASTLEGGEN - AAN',
    CAMERA_SMARTCAPTURE_OFF: 'AUTOMATISCHE VASTLEGGEN - UIT',
    CAMERA_CAPTURE_FRONT:
        'Plaats de kant met de foto van uw identiteitsdocument in het kader hieronder.',
    CAMERA_MANUAL_CAPTURE_FRONT:
        'Plaats uw identiteitsbewijs binnen het kader en klik op de onderstaande knop',
    CAMERA_CAPTURE_BACK:
        'Plaats de ACHTERKANT van uw identiteitsbewijs binnen het kader',
    CAMERA_CAPTURE_SELFIE_CAPTION:
        'Plaats uw gezicht binnen het ovaal, kijk recht in de camera en klik op de onderstaande knop om een ​​selfie te maken.',
    AMERA_CAPTURE_ADDRESS_CAPTION:
        'Plaats uw adresbewijs binnen het kader en klik op de onderstaande knop om een ​​foto te maken.',
    CAMERA_CAPTURE_COVID_CAPTION:
        'Plaats uw Covid-document binnen het kader en klik op de onderstaande knop om een ​​foto te maken.',
    CAMERA_PREVENT_GLARE_HINT:
        'Beweeg het document weg van directe lichtbronnen.',
    CAMERA_PREVENT_BLUR_HINT: 'Houd het document of apparaat stil.',
    CAMERA_PREVENT_LOW_RES_HINT:
        'Plaats het document volledig binnen het kader.',
    CROPPER_RETRY: 'Opnieuw proberen',
    CROPPER_UPLOAD: 'Uploaden',
    CROPPER_UPLOADING: 'Uploaden...',
    FILESYSTEM_SELECT: 'Selecteren',
    FILESYSTEM_DROP_IMAGE: 'of Afbeelding verwijderen',
    GATEWAY_CAMERA: 'Camera ingeschakeld',
    GATEWAY_CANCEL: 'Reis annuleren',
    LIVENESS_START: 'Liveness starten',
    PASSIVE_LIVENESS_START: 'Foto maken',
    LOGIN_USERNAME: 'Gebruikersnaam',
    LOGIN_PASSWORD: 'Wachtwoord',
    LOGIN_SUBMIT: 'Indienen',
    RESULTS_DOCUMENTS: 'Documenten',
    RESULTS_DOCUMENTS_NONE: 'Niet gevonden',
    RESULTS_DOCUMENT_TYPE: 'Documenttype',
    RESULTS_DOCUMENT_RESULT: 'Documentresultaat',
    RESULTS_EXTRACTED_FIELDS_NONE: 'Resultaatdetails',
    RESULTS_DETAILS_NONE: 'Niet gevonden',
    RESULTS_NEW_JOURNEY: 'Begin een nieuwe reis.',
    RESULTS_NO_INFORMATION: 'Er is geen informatie voor deze reis',
    RESULTS_LOGOUT: 'Afmelden',
    RESULTS_HIGH_LEVEL_Aborted: 'Afgebroken',
    RESULTS_HIGH_LEVEL_TCCDISAGREE: 'Afgebroken Algemene Voorwaarden',
    RESULTS_HIGH_LEVEL_Expired: 'Verlopen',
    RESULTS_HIGH_LEVEL_NotAccepted: 'Niet geaccepteerd.',
    RESULTS_HIGH_LEVEL_NotSupported: 'Niet ondersteund',
    RESULTS_HIGH_LEVEL_Notsupported: 'Niet ondersteund',
    RESULTS_HIGH_LEVEL_Passed: 'Geslaagd',
    RESULTS_HIGH_LEVEL_Refer: 'Verwijzen',
    RESULTS_HIGH_LEVEL_Undefined: 'Ongedefinieerd',
    RESULTS_HIGH_LEVEL_DETAIL_ACCUMULATIVELIVENESSRESULT:
        'Accumulatieve Levendigheidsresultaat',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTFRONTSIDETYPECHECK:
        'Document voorzijde Type Controle',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTBACKSIDECHECK:
        'Document Achterkant Controle',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTBLOCKINGPOLICY:
        'Document Blokkeringsbeleid',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTEXPIRY: 'Document Vervaldatum',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTSUPPORT: 'Document Ondersteuning',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTVALIDATION: 'Documentvalidatie',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTPROOFPOLICY: 'Document Bewijsbeleid',
    RESULTS_HIGH_LEVEL_DETAIL_FACEMATCHVALIDATION: 'Facematch Validatie',
    RESULTS_HIGH_LEVEL_DETAIL_UNDERAGERULE: 'Minderjarigenregel',
    ESULTS_HIGH_LEVEL_DETAIL_VALUE_SUCCESS_NEEDED: 'Succes nodig',
    RESULTS_HIGH_LEVEL_DETAIL_COVID_PASS_CROSSCHECK:
        'De compatibiliteit van het Covid-paspoort controleren',
    RESULTS_HIGH_LEVEL_DETAIL_DATA_CHECK: 'Gegevenscontroles',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_FAILED: 'Mislukt',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_NOTNEEDED: 'Niet nodig.',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_PASSED: 'Geslaagd',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_SKIPPED: 'Overgeslagen',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_UNDETERMINED: 'Onbepaald',
    ADDITIONAL_CHECKS_DETAILS: 'Aanvullende controles',
    ADDITIONAL_CHECKS_DETAILS_NONE: 'Geen gevonden',
    ADDITIONAL_CHECKS_DETAIL_DATACHECKS: 'Gegevens Controles',
    ADDITIONAL_CHECKS_DETAIL_LOOKBACKCHECK: 'Terugkijkcontroles',
    ADDITIONAL_CHECKS_DETAIL_LOOKBACKCHECK_NA: 'N/A',
    GBG_SCORES: 'GBG Scores',
    GBG_TRUST_SCORE: 'GBG Vertrouwensscore',
    GBG_SCORE: 'GBG Score',
    PREVIEW_TITLE: 'Is de foto van uw document duidelijk?',
    VIEW_RETRY: 'MAAK OPNIEUW FOTO',
    VIEW_RETRY_DESKTOP: 'Foto wijzigen',
    VIEW_CROP: 'Oogst',
    VIEW_CROPPING: 'Bijsnijden...',
    VIEW_UPLOAD: 'Upload',
    VIEW_UPLOAD_PREVIEW: 'JA, DOORGAAN',
    VIEW_UPLOADING: 'Uploaden...',
    SMART_CAPTURE_INITIALIZING: 'Begin',
    SMART_CAPTURE_START:
        'Initialiseren van Slimme Opname, Even geduld a.u.b...',
    SCANNER_DESC_AVAILABLE:
        'De scanner is beschikbaar. Plaats uw document in de scanner.',
    SCANNER_DESC_PROCESSING: 'De afbeelding wordt verwerkt door de server.',
    SCANNER_DESC_SCANNING: 'Het beeld wordt gescand door het apparaat.',
    SCANNER_DESC_DISCONNECTED: 'De scanner is losgekoppeld van het netwerk.',
    SCANNER_DESC_NOT_CONNECTED: 'De scanner is niet aangesloten.',
    SCANNER_DESC_OFFLINE: 'De scanner is offline.',
    SCANNER_DESC_BUSY:
        'De scanner wordt gebruikt door een andere gebruiker in uw lokale netwerk.',
    SCANNER_DESC_WAITING: 'Wachten tot de verbinding tot stand is gebracht.',
    SCANNER_DESC_LOADING: 'Even geduld...',
    SCANNER_TITLE_SCANNING: 'Scannen...',
    SCANNER_TITLE_DISCONNECTED: 'ONDERBROKEN',
    SCANNER_TITLE_NOT_CONNECTED: 'NIET VERBONDEN',
    SCANNER_TITLE_OFFLINE: 'Scanner offline',
    SCANNER_TITLE_BUSY: 'Scanner Bezet',
    SCANNER_TITLE_WAITING: 'WACHTEN',
    SCANNER_ACTION_REGISTER: 'Registreren',
    SCANNER_ACTION_RELEASE: 'Vrijlating',
    CANCEL_JOURNEY: 'Annuleren',
    MANUAL_PHOTO_UPLOAD_TOGGLE_FALSE: 'Upload een foto in plaats daarvan',
    MANUAL_PHOTO_UPLOAD_TOGGLE_TRUE: 'Maak in plaats daarvan een foto',
    JOURNEY_SELECT_CONTINUE: 'Ga verder',
    HELP_MODAL_AUTOCAPTURE_TITLE:
        'Zo maak je een foto van je identiteitsbewijs',
    HELP_MODAL_AUTOCAPTURE_SUBTITLE:
        'Als Automatisch vastleggen is ingeschakeld, maakt het vastlegscherm automatisch een foto van je document als het herkent dat de kwaliteit goed genoeg is.',
    HELP_MODAL_AUTOCAPTURE_TIPS:
        'Tips voor het maken van een foto van goede kwaliteit',
    HELP_MODAL_AUTOCAPTURE_GLARE_TITLE: 'Voorkom schittering',
    HELP_MODAL_AUTOCAPTURE_GLARE_SUBTITLE:
        'Plaats het document uit de buurt van directe lichtbronnen.',
    HELP_MODAL_AUTOCAPTURE_FAR_TITLE: 'Document te ver weg',
    AUTOCAPTURE_FAR_SUBTITLE: 'Plaats het document volledig in het frame.',
    AUTOCAPTURE_BLUR_TITLE: 'Wazigheid voorkomen',
    HELP_MODAL_AUTOCAPTURE_BLUR_SUBTITLE: 'Houd het document of apparaat stil.',
    HELP_MODAL_AUTOCAPTURE_MANUAL_CAPTURE:
        'Nog steeds moeite? Maak een foto met Handmatig vastleggen',
    HELP_MODAL_AUTOCAPTURE_TURN_MANUAL_CAPTURE: 'Handmatig vastleggen',
    HELP_MODAL_SELFIE_TITLE: 'Zo maak je een selfie',
    HELP_MODAL_SELFIE_SUBTITLE:
        'Kijk recht in de camera en klik op de knop Manual Capture.',
    HELP_MODAL_POA_TITLE: 'Zo maak je een foto van je bewijs van adres',
    HELP_MODAL_POA_SUBTITLE:
        'Plaats je document binnen het kader en klik op de vastlegknop om een foto van je document te maken.',
    HELP_MODAL_POA_TIPS: 'Tips voor het maken van een foto van goede kwaliteit',
    HELP_MODAL_POA_GLARE_TITLE: 'Voorkom schittering',
    HELP_MODAL_POA_GLARE_SUBTITLE:
        'Plaats het document uit de buurt van directe lichtbronnen.',
    HELP_MODAL_POA_FAR_TITLE: 'Document te ver',
    HELP_MODAL_POA_FAR_SUBTITLE:
        'Plaats het document volledig binnen het kader.',
    HELP_MODAL_POA_BLUR_TITLE: 'Voorkom onscherpte',
    HELP_MODAL_POA_BLUR_SUBTITLE: 'Houd het document of apparaat stil.',
    HELP_MODAL_POA_MANUAL_CAPTURE:
        'Nog steeds moeite? Schakel Handmatig vastleggen in',
    HELP_MODAL_POA_TURN_MANUAL_CAPTURE: 'Handmatig vastleggen',
    HELP_MODAL_COVID_TITLE: 'Zo maak je een foto van je Covid-document',
    HELP_MODAL_COVID_SUBTITLE:
        'Plaats je document binnen het kader en klik op de vastlegknop om een foto van je document te maken.',
    HELP_MODAL_COVID_TIPS:
        'Tips voor het maken van een foto van goede kwaliteit',
    HELP_MODAL_COVID_GLARE_TITLE: 'Voorkom schittering',
    HELP_MODAL_COVID_GLARE_SUBTITLE:
        'Plaats het document uit de buurt van directe lichtbronnen.',
    HELP_MODAL_COVID_FAR_TITLE: 'Document te ver',
    HELP_MODAL_COVID_FAR_SUBTITLE:
        'Plaats het document volledig binnen het kader.',
    HELP_MODAL_COVID_BLUR_TITLE: 'Wazigheid voorkomen',
    HELP_MODAL_COVID_BLUR_SUBTITLE: 'Houd het document of apparaat stil.',
    HELP_MODAL_COVID_MANUAL_CAPTURE:
        'Nog steeds moeite? Schakel Handmatig vastleggen in',
    HELP_MODAL_COVID_TURN_MANUAL_CAPTURE: 'Handmatig opnemen',
    HELP_MODAL_NEED_HELP: 'Hulp en opties',
    EXCEPTION: 'Er is een onverwachte uitzondering opgetreden',
    EXCEPTION_AUTHORIZATION: 'Ongeautoriseerd',
    EXCEPTION_AUTHORIZATION_ACCOUNT_NOT_AUTHORIZED:
        'Uw account heeft geen toegang tot deze bron',
    EXCEPTION_AUTHORIZATION_AUTH_DETAILS_INVALID:
        'Gebruikersnaam en wachtwoord combinatie is niet geldig',
    EXCEPTION_AUTHORIZATION_AUTH_NOT_ENABLED:
        'U moet auth inschakelen om deze functie te gebruiken',
    EXCEPTION_AUTHORIZATION_PROCESS_NOT_AUTHORIZED:
        'U bent niet bevoegd voor dit proces',
    EXCEPTION_BAD_REQUEST: 'Slecht verzoek met statuscode 400',
    EXCEPTION_BAD_REQUEST_INVALID_IMAGE: 'Geen geldige afbeelding',
    EXCEPTION_BAD_REQUEST_WAITING_FOR_RESPONSE: 'De reis wacht op een antwoord',
    EXCEPTION_FLOW_STATE_JOURNEY_ENDED:
        'Kan geen verzoeken verzenden. De reis is beëindigd',
    EXCEPTION_FLOW_STATE_MISSING: 'Flowstatus niet gevonden',
    EXCEPTION_INVALID_PARAMETER_CALLBACK_MUST_BE_FUNCTION:
        'Callback moet een geldige functie zijn.',
    EXCEPTION_INVALID_PARAMETER_NAME_MUST_BE_STRING:
        'De naam van het evenement moet een tekenreekswaarde zijn.',
    EXCEPTION_INVALID_PARAMETER_PRIORITY_MUST_BE_NUMBER:
        'Prioriteit moet een nummer zijn.',
    EXCEPTION_INVALID_PARAMETER_PRIORITY_MUST_BE_POSITIVE_NUMBER:
        'Prioriteit moet een positief getal zijn.',
    EXCEPTION_INVALID_PARAMETER_SHOULD_BE_ELEMENT_OR_SELECTOR:
        'Container moet ofwel een element of een selector zijn.',
    EXCEPTION_INVALID_PARAMETER_VALUE_NOT_VALID: 'Waarde is niet geldig.',
    EXCEPTION_INVALID_PARAMETER_VALUE_DAMAGED: 'Waarde is beschadigd.',
    EXCEPTION_MISSING_PARAMETER_BACKEND_URL_MISSING:
        'Configuratie moet een backendUrl parameter bevatten.',
    EXCEPTION_MISSING_PARAMETER_COORDINATES_MISSING:
        'Geleverde parameters moeten coördinaten bevatten.',
    EXCEPTION_MISSING_PARAMETER_IMAGES_MISSING:
        'Geleverde parameters moeten afbeeldingen bevatten.',
    EXCEPTION_MISSING_PARAMETER_PASSWORD_MISSING:
        'Geleverde parameters moeten wachtwoord bevatten.',
    EXCEPTION_MISSING_PARAMETER_USERNAME_MISSING:
        'Geleverde parameters moeten gebruikersnaam bevatten.',
    EXCEPTION_MISSING_REQUIRED_FIELD_MISSING: 'Vul alle verplichte velden in',
    EXCEPTION_POSTCODE_FORMAT_ERROR:
        'Postcode formaat is ongeldig minLengte:5 / maxLengte:8',
    EXCEPTION_HOUSENUMBER_FORMAT_ERROR:
        'Huisnaam/huisnummer notatie is ongeldig minLengte:1 / maxLengte:20',
    EXCEPTION_STREETNAME_FORMAT_ERROR:
        'Straatnaam is ongeldig minLengte:1 / maxLengte:30',
    EXCEPTION_TOWN_FORMAT_ERROR:
        'Stad formaat is ongeldig minLengte:1 / maxLengte:20',
    EXCEPTION_JOURNEY_DEFINITIONS_MISSING:
        'Er zijn geen reisdefinities beschikbaar voor dit kanaal',
    EXCEPTION_NETWORK:
        'Er is een netwerkuitzondering opgetreden, controleer uw verbinding en probeer het opnieuw',
    EXCEPTION_PLATFORM_BROWSER_ONLY:
        'Deze functie kan alleen in de browser worden gebruikt',
    EXCEPTION_PLATFORM_UNSUPPORTED: 'Uw omgeving ondersteunt deze functie niet',
    EXCEPTION_PLATFORM_CAMERA_PERMISSION_DENIED:
        'Camerarechten zijn niet toegekend, controleer uw browserinstellingen',
    EXCEPTION_PLATFORM_CAMERA_PERMISSION_UNAVAILABLE: '',
    EXCEPTION_PLATFORM_CAMERA_NOT_READABLE:
        'De camera kon niet worden benaderd. Sluit andere toepassingen en probeer het opnieuw',
    EXCEPTION_PLATFORM_CAMERA_NONE_SUITABLE:
        "Er zijn geen geschikte camera's gevonden op uw apparaat",
    EXCEPTION_SERVER: 'Verzoek mislukt met statuscode 500',
    EXCEPTION_SERVER_UNREACHABLE: 'Aanvraag mislukt, server onbereikbaar',
    EXCEPTION_SERVER_DATA_NOT_PERSISTED:
        'Er is een fout opgetreden tijdens het proces. Uw gegevens worden mogelijk niet opgeslagen',
    EXCEPTION_SERVER_RESULT_NOT_PASSING: 'Huidig resultaat komt niet voorbij',
    EXCEPTION_TEMPLATE_CANVAS_CONTEXT_UNAVAILABLE:
        'Canvas context niet beschikbaar',
    EXCEPTION_TEMPLATE_CONTAINER_MISSING: 'Container is niet aanwezig',
    EXCEPTION_TEMPLATE_ELEMENTS_MISSING: 'Verplichte elementen ontbreken',
    EXCEPTION_TEMPLATE_MISSING: 'Sjabloon niet gevonden',
    EXCEPTION_TEMPLATE_SOURCE_ELEMENT_MISSING: 'Kan bronelement niet vinden',
    EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_CANNOT_RETRIEVE:
        'Kan invoerproviders niet krijgen',
    EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_NONE_SPECIFIED:
        'Geen invoerproviders gespecificeerd',
    EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_NOT_AVAILABLE:
        'Invoerprovider is niet beschikbaar',
    'SUPPORTED_DOCUMENT_Account Statement': 'Rekeningoverzicht',
    'SUPPORTED_DOCUMENT_Agreement (Tenancy)': 'Overeenkomst (Huur)',
    'SUPPORTED_DOCUMENT_Bank Document': 'Bankdocument',
    'SUPPORTED_DOCUMENT_Bank Letter': 'Bankbrief',
    'SUPPORTED_DOCUMENT_Bank Statement': 'Bankafschrift',
    'SUPPORTED_DOCUMENT_Benefit Letter': 'Voordelenbrief',
    'SUPPORTED_DOCUMENT_Certificate (Birth, Marriage, Civil partnership)':
        'Certificaat (Geboorte, Huwelijk, Geregistreerd partnerschap)',
    'SUPPORTED_DOCUMENT_Council Document': 'Raadsdocument',
    'SUPPORTED_DOCUMENT_Council Letter': 'Raadsbrief',
    'SUPPORTED_DOCUMENT_Council Tax': 'Gemeentebelasting',
    'SUPPORTED_DOCUMENT_Driving License': 'Rijbewijs',
    'SUPPORTED_DOCUMENT_Driving Licence': 'Rijbewijs',
    'SUPPORTED_DOCUMENT_DWP Document': 'DWP Document',
    'SUPPORTED_DOCUMENT_HMRC Document': 'HMRC Document',
    'SUPPORTED_DOCUMENT_Information Sheet': 'Informatieblad',
    'SUPPORTED_DOCUMENT_Insurance Document': 'Verzekeringsdocument',
    'SUPPORTED_DOCUMENT_Insurance Letter': 'Verzekeringsbrief',
    SUPPORTED_DOCUMENT_Invoice: 'Factuur',
    'SUPPORTED_DOCUMENT_NIC Letter': 'NIC Brief',
    'SUPPORTED_DOCUMENT_NINO Letter': 'NINO Brief',
    'SUPPORTED_DOCUMENT_Official Document': 'Officieel document',
    'SUPPORTED_DOCUMENT_Official Letter': 'Officiële brief',
    'SUPPORTED_DOCUMENT_Repayment Letter (related to Tax or Social support)':
        'Aflossingsbrief (gerelateerd aan belasting of sociale ondersteuning)',
    'SUPPORTED_DOCUMENT_Tax Letter': 'Belastingbrief',
    'SUPPORTED_DOCUMENT_Tax Statement': 'Belastingaangifte',
    'SUPPORTED_DOCUMENT_Tel Bill': 'Bel Bill',
    'SUPPORTED_DOCUMENT_Tel Letter': 'Tel Letter',
    'SUPPORTED_DOCUMENT_Telecommunication Document': 'Telecommunicatiedocument',
    'SUPPORTED_DOCUMENT_TV Licence': 'TV-licentie',
    'SUPPORTED_DOCUMENT_University Letter': 'Universiteitsbrief',
    'SUPPORTED_DOCUMENT_Utility Bill': 'Hulprekening',
    'SUPPORTED_DOCUMENT_Utility Document': 'Hulpprogramma Document',
    'SUPPORTED_DOCUMENT_Utility Letter': 'Dienstbrief',
    'SUPPORTED_DOCUMENT_Water Bil': 'Waterrekening',
    'SUPPORTED_DOCUMENT_Water Document': 'Waterdocument',
    'SUPPORTED_DOCUMENT_Agents License': 'Makelaarsvergunning',
    'SUPPORTED_DOCUMENT_Electoral Card': 'Kieskaart',
    'SUPPORTED_DOCUMENT_Foreigner Identification Card':
        'Buitenlanderidentificatiekaart',
    'SUPPORTED_DOCUMENT_Health Card': 'Gezondheidskaart',
    'SUPPORTED_DOCUMENT_Job License': 'Werkvergunning',
    'SUPPORTED_DOCUMENT_Membership Identification Card':
        'Lidmaatschapsidentificatiekaart',
    'SUPPORTED_DOCUMENT_Military Identification Card':
        'Militair Identificatiekaart',
    'SUPPORTED_DOCUMENT_National Identification Card':
        'Nationaal Identiteitsbewijs',
    SUPPORTED_DOCUMENT_Passport: 'Paspoort',
    'SUPPORTED_DOCUMENT_Travel Permit': 'Reisvergunning',
    SUPPORTED_DOCUMENT_Visa: 'Visum',
    'SUPPORTED_DOCUMENT_Weapons Licence': 'Wapenvergunning',
    'SUPPORTED_DOCUMENT_Selfie Photo': 'Selfie Foto',
    SUPPORTED_DOCUMENT_Unknown: 'Onbekend',
    SUPPORTED_DOCUMENT_COVIDPAS: 'Covid pas',
    EXTRACTED_FIELDS_AddressFull: 'Adres Volledig',
    EXTRACTED_FIELDS_AddressCity: 'Adres Stad',
    EXTRACTED_FIELDS_AddressPostCode: 'Adres Postcode',
    EXTRACTED_FIELDS_LastNameFirstPart: 'Achternaam Eerste Deel',
    EXTRACTED_FIELDS_Sex: 'Køn',
    EXTRACTED_FIELDS_BirthPlace: 'Geboorteplaats',
    EXTRACTED_FIELDS_IssueNumber: 'Probleemnummer',
    EXTRACTED_FIELDS_DocumentNumberCheckDigit: 'Documentnummer Controlecijfer',
    EXTRACTED_FIELDS_BirthDate: 'Geboortedatum',
    EXTRACTED_FIELDS_DocumentNumber: 'Documentnummer',
    EXTRACTED_FIELDS_FirstName: 'Voornaam',
    EXTRACTED_FIELDS_ArbitraryDigit: 'Willekeurig Cijfer',
    EXTRACTED_FIELDS_FirstNameInitial: 'Voornaam initiaal',
    EXTRACTED_FIELDS_ExpiryDate: 'Vervaldatum',
    EXTRACTED_FIELDS_IssueDate: 'Uitgiftedatum',
    EXTRACTED_FIELDS_LastName: 'Achternaam',
    EXTRACTED_FIELDS_LicenseCategory: 'Licentiecategorie',
    EXTRACTED_FIELDS_DocumentCategory: 'Document Categorie',
    EXTRACTED_FIELDS_DocumentType: 'Documenttype',
    EXTRACTED_FIELDS_NationalityCode: 'Nationaliteitscode',
    EXTRACTED_FIELDS_MiddleName: 'Tweede naam',
    EXTRACTED_FIELDS_FirstIssuanceDate: 'Eerste uitgiftedatum',
    EXTRACTED_FIELDS_SecondLastName: 'Tweede achternaam',
    EXTRACTED_FIELDS_FullName: 'Volledige naam',
    EXTRACTED_FIELDS_PersonalNumber: 'Persoonlijk nummer',
    EXTRACTED_FIELDS_NationalityName: 'Nationaliteit',
    EXTRACTED_FIELDS_BarcodeItems: 'BarcodeS',
    EXTRACTED_FIELDS_BirthPlaceCity: 'Geboorteplaats',
    EXTRACTED_FIELDS_BirthPlaceState: 'Geboortestaat',
    EXTRACTED_FIELDS_BirthPlaceCountry: 'Land van geboorte',
    EXTRACTED_FIELDS_MRZFull: 'Volledige MRZ',
    EXTRACTED_FIELDS_MRZLine1: 'MRZ-regel 1',
    EXTRACTED_FIELDS_MRZLine2: 'MRZ-regel 2',
    EXTRACTED_FIELDS_MRZLine3: 'MRZ-regel 3',
    EXTRACTED_FIELDS_ObservationPage: 'Observatiepagina',
    EXTRACTED_FIELDS_IssuingAuthority: 'Uitgevende instantie',
    EXTRACTED_FIELDS_IssuingLocation: 'Uitgifteplaats',
    EXTRACTED_FIELDS_MaritalStatus: 'Burgerlijke staat',
    EXTRACTED_FIELDS_Occupation: 'Beroep',
    EXTRACTED_FIELDS_AlienNumber: 'Buitenaards Nummer',
    EXTRACTED_FIELDS_Employer: 'Werkgever',
    EXTRACTED_FIELDS_AddressLine1: 'Adresregel 1',
    EXTRACTED_FIELDS_AddressLine2: 'Adresregel 2',
    EXTRACTED_FIELDS_AddressLine3: 'Adresregel 3',
    EXTRACTED_FIELDS_AddressLine4: 'Adresregel 4',
    EXTRACTED_FIELDS_AddressState: 'Staat',
    EXTRACTED_FIELDS_AddressDistrict: 'District',
    EXTRACTED_FIELDS_AddressBuildingNumber: 'Gebouwnummer',
    EXTRACTED_FIELDS_AddressBuildingName: 'Gebouw Naam',
    EXTRACTED_FIELDS_AddressStreet: 'Straat',
    EXTRACTED_FIELDS_AddressCountry: 'Land',
    EXTRACTED_FIELDS_RefAddressFull: 'Referentieadres',
    EXTRACTED_FIELDS_RefAddressLine1: 'Referentie Adresregel 1',
    EXTRACTED_FIELDS_RefAddressLine2: 'Referentie Adresregel 2',
    EXTRACTED_FIELDS_RefAddressLine3: 'Referentie Adresregel 3',
    EXTRACTED_FIELDS_RefAddressLine4: 'Referentie Adresregel 4',
    EXTRACTED_FIELDS_RefAddressCity: 'Referentie Adres Stad',
    EXTRACTED_FIELDS_RefAddressState: 'Referentie Adres Staat',
    EXTRACTED_FIELDS_RefAddressDistrict: 'Referentie Adres District',
    EXTRACTED_FIELDS_RefAddressBuildingNumber: 'Referentieadres Gebouwnummer',
    EXTRACTED_FIELDS_RefAddressBuildingName: 'Referentieadres Gebouwnaam',
    EXTRACTED_FIELDS_RefAddressSubBuildingName: 'Referentieadres Subgebouwnaam',
    EXTRACTED_FIELDS_RefAddressStreet: 'Referentieadres Straat',
    EXTRACTED_FIELDS_RefAddressCountry: 'Referentie Adres Land',
    EXTRACTED_FIELDS_RefAddressPostCode: 'Referentie Adres Postcode',
    EXTRACTED_FIELDS_HealthNumber: 'Gezondheidsnummer',
    EXTRACTED_FIELDS_Endorsements: 'Aanbevelingen',
    EXTRACTED_FIELDS_Constraints: 'Beperkingen',
    EXTRACTED_FIELDS_LicenseMarine: 'Maritieme vergunning',
    EXTRACTED_FIELDS_Height: 'Hoogte',
    EXTRACTED_FIELDS_Weight: 'Gewicht',
    EXTRACTED_FIELDS_HairColor: 'Haarkleur',
    EXTRACTED_FIELDS_EyeColor: 'Oogkleur',
    EXTRACTED_FIELDS_LensData: 'Gezichtsvermogen',
    EXTRACTED_FIELDS_SocialSecurityNumber: 'Burgerservicenummer',
    EXTRACTED_FIELDS_NationalInsuranceNumber: 'Burgerservicenummer',
    EXTRACTED_FIELDS_Race: 'Ras',
    EXTRACTED_FIELDS_MotherName: 'Moeders Naam',
    EXTRACTED_FIELDS_FatherName: "Vader's naam",
    EXTRACTED_FIELDS_Parents: 'Ouders',
    EXTRACTED_FIELDS_Remarks: 'Opmerkingen',
    EXTRACTED_FIELDS_DistinguishingMarks: 'Onderscheidende kenmerken',
    EXTRACTED_FIELDS_PeriodOfStay: 'Verblijfsperiode',
    EXTRACTED_FIELDS_TaxNumber: 'Belastingnummer',
    EXTRACTED_FIELDS_Donor: 'Donor',
    EXTRACTED_FIELDS_RFIDG1: 'RFID Ruwe Gegevens Groep 1',
    EXTRACTED_FIELDS_RFIDG2: 'RFID Ruwe Gegevens Groep 2',
    EXTRACTED_FIELDS_RFIDG3: 'RFID Ruwe Gegevens Groep 3',
    EXTRACTED_FIELDS_RFIDG15: 'RFID Ruwe Gegevens Groep 4',
    EXTRACTED_FIELDS_RFIDSOD: 'RFID Ruwe Gegevens Groep 5',
    EXTRACTED_FIELDS_PortraitPhoto: 'Geëxtraheerde portretfoto',
    EXTRACTED_FIELDS_Title: 'Titel',
    EXTRACTED_FIELDS_IssueDate2: 'Tweede Uitgiftedatum',
    EXTRACTED_FIELDS_ExpiryDate2: 'Tweede vervaldatum',
    EXTRACTED_FIELDS_LicenseCategory2: 'Tweede Licentiecategorie',
    EXTRACTED_FIELDS_IssueDate3: 'Derde Uitgiftedatum',
    EXTRACTED_FIELDS_ExpiryDate3: 'Derde Vervaldatum',
    EXTRACTED_FIELDS_LicenseCategory3: 'Derde Licentiecategorie',
    EXTRACTED_FIELDS_IssueDate4: 'Vierde Uitgiftedatum',
    EXTRACTED_FIELDS_ExpiryDate4: 'Vierde Vervaldatum',
    EXTRACTED_FIELDS_LicenseCategory4: 'Vierde Licentiecategorie',
    EXTRACTED_FIELDS_MRZCode1: 'MRZ-code 1',
    EXTRACTED_FIELDS_MRZCode2: 'MRZ-code 2',
    EXTRACTED_FIELDS_MRZStandardType: 'MRZ Standaard Type',
    EXTRACTED_FIELDS_AddressStreetSuffix: 'Straat Achtervoegsel',
    EXTRACTED_FIELDS_AddressStreetType: 'Straat Type',
    EXTRACTED_FIELDS_AddressUnitNumber: 'Adres Eenheid Nummer',
    EXTRACTED_FIELDS_LicenseNumber: 'Licentienummer',
    EXTRACTED_FIELDS_AddressStateCode: 'Staatcode',
    EXTRACTED_FIELDS_AddressStreetTypeAbbreviation: 'Straatafkorting',
    EXTRACTED_FIELDS_AddressUnitType: 'Adres Eenheid Type',
    EXTRACTED_FIELDS_AddressDeliveryPointIdentifier: 'Afleverpuntidentificator',
    EXTRACTED_FIELDS_AgeCategory: 'Leeftijdscategorie',
    EXTRACTED_FIELDS_ChildernCount: 'Aantal kinderen',
    EXTRACTED_FIELDS_EntryMode: 'Invoermodus',
    EXTRACTED_FIELDS_VAFNumber: 'VAF-nummer',
    EXTRACTED_FIELDS_AddressLine5: 'Adresregel 5',
    EXTRACTED_FIELDS_RFIDPortraitPhoto: 'RFID Portretfoto',
    EXTRACTED_FIELDS_RefAddressLine5: 'Referentie Adresregel 5',
    EXTRACTED_FIELDS_RefAddressStateCode: 'Referentie Adres Staat',
    EXTRACTED_FIELDS_RefAddressStreetType: 'Referentie Adres Straat Type',
    EXTRACTED_FIELDS_RefAddressStreetTypeAbbreviation:
        'Referentie Adres Straat Type Afkorting',
    EXTRACTED_FIELDS_RefAddressStreetSuffix:
        'Referentie Adres Straat Achtervoegsel',
    EXTRACTED_FIELDS_RefAddressUnitNumber: 'Referentie Adres Unit Nummer',
    EXTRACTED_FIELDS_RefAddressUnitType: 'Referentie Adres Eenheid Type',
    EXTRACTED_FIELDS_RefAddressPostcodeType: 'Referentie Adres Postcode Type',
    EXTRACTED_FIELDS_RefAddressDeliveryPointIdentifier:
        'Referentieadres Bezorgpunt Identificator',
    EXTRACTED_FIELDS_RefAddressPOBoxNumber: 'Referentieadres Postbusnummer',
    EXTRACTED_FIELDS_RefAddressDependentLocality:
        'Referentie Adres Afhankelijke Locatie',
    EXTRACTED_FIELDS_RefAddressDoubleDependentLocality:
        'Referentieadres Dubbele Afhankelijke Plaatsnaam',
    EXTRACTED_FIELDS_RefAddressThoroughfare: 'Referentieadres Straatnaam',
    EXTRACTED_FIELDS_RefAddressThoroughfareDesc:
        'Referentieadres Straatbeschrijving',
    EXTRACTED_FIELDS_RefAddressDependentThoroughfare:
        'Referentie Adres Afhankelijke Doorgangweg',
    EXTRACTED_FIELDS_RefAddressDependentThoroughfareDesc:
        'Referentieadres Afhankelijke Thoroughfare-beschrijving',
    EXTRACTED_FIELDS_RefAddressSubBuildingNumber:
        'Referentieadres Subgebouwnummer',
    EXTRACTED_FIELDS_AddressSubBuildingNumber: 'Gebouwnummer',
    EXTRACTED_FIELDS_AddressSubBuildingName: 'Gebouwnaam',
    EXTRACTED_FIELDS_AddressPostCodeType: 'Postcode Type',
    EXTRACTED_FIELDS_IssuingAuthorityType: 'Uitgevende instantietype',
    EXTRACTED_FIELDS_Signature: 'Handtekening',
    EXTRACTED_FIELDS_Hologram: 'Hologram',
    EXTRACTED_FIELDS_CardNumber: 'Kaartnummer',
    EXTRACTED_FIELDS_MiddleNameInitial: 'Middelste Naam Initiaal',
    EXTRACTED_FIELDS_PermitNumber: 'Vergunningsnummer',
    EXTRACTED_FIELDS_ReferenceNumber: 'Referentienummer',
    EXTRACTED_FIELDS_CustomerNumber: 'Klantnummer',
    EXTRACTED_FIELDS_BOSNumber: 'BOS Nummer',
    EXTRACTED_FIELDS_StudentID: 'Student Identificatienummer',
    EXTRACTED_FIELDS_MembershipNumber: 'Lidmaatschapsnummer',
    EXTRACTED_FIELDS_LicenseType: 'Licentietype',
    EXTRACTED_FIELDS_LicenseType2: 'Licentietype 2',
    EXTRACTED_FIELDS_LicenseType3: 'Licentietype 3',
    EXTRACTED_FIELDS_LicenseType4: 'Licentietype 4',
    EXTRACTED_FIELDS_DocumentTypeCode: 'Document Type Code',
    EXTRACTED_FIELDS_MRZDocumentNumberCheckDigit: 'MRZ Controlecijfer',
    EXTRACTED_FIELDS_MRZBirthDateCheckDigit: 'MRZ Geboortedatum Controlecijfer',
    EXTRACTED_FIELDS_MRZExpiryDateCheckDigit: 'MRZ Vervaldatum Controlecijfer',
    EXTRACTED_FIELDS_MRZPersonalNumberCheckDigit:
        'MRZ Persoonlijk Nummer Controlecijfer',
    EXTRACTED_FIELDS_MRZCompositeCheckDigit: 'MRZ Samengestelde Controlecijfer',
    EXTRACTED_FIELDS_SecondaryPortraitPhoto: 'Secundaire portretfoto',
    EXTRACTED_FIELDS_Fingerprint: 'Vingerafdruk',
    EXTRACTED_FIELDS_VersionNumber: 'Versienummer',
    EXTRACTED_FIELDS_Conditions: 'Voorwaarden',
    EXTRACTED_FIELDS_NickName: 'Bijnaam',
    EXTRACTED_FIELDS_AddressApartmentNumber: 'Appartementnummer',
    EXTRACTED_FIELDS_AddressFloorNumber: 'Verdiepingsnummer',
    EXTRACTED_FIELDS_FirstNameLocal: 'Voornaam ter plaatse',
    EXTRACTED_FIELDS_LastNameLocal: 'Achternaam Lokale',
    EXTRACTED_FIELDS_FullNameLocal: 'Volledige naam Lokale',
    EXTRACTED_FIELDS_BirthPlaceLocal: 'Geboorteplaats Lokale',
    EXTRACTED_FIELDS_IssuingAuthorityLocal: 'Uitgevende instantie lokaal',
    EXTRACTED_FIELDS_MotherNameLocal: 'Moeder Naam Lokale',
    EXTRACTED_FIELDS_FatherNameLocal: 'Vader Naam Lokale',
    EXTRACTED_FIELDS_AddressFullLocal: 'Adres Volledig Lokaal',
    EXTRACTED_FIELDS_MiddleNameLocal: 'Middelste Naam Lokale',
    EXTRACTED_FIELDS_AddressLine1Local: 'Adresregel 1 Lokale',
    EXTRACTED_FIELDS_AddressLine2Local: 'Adresregel 2 Lokale',
    EXTRACTED_FIELDS_AddressLine3Local: 'Adresregel 3 Lokale',
    EXTRACTED_FIELDS_IndRefNumber1: 'Individueel referentienummer 1',
    EXTRACTED_FIELDS_IndRefNumber2: 'Individueel referentienummer 2',
    EXTRACTED_FIELDS_IndRefNumber3: 'Individueel Referentienummer 3',
    EXTRACTED_FIELDS_IndRefNumber4: 'Individueel referentienummer 4',
    EXTRACTED_FIELDS_IndRefNumber5: 'Individueel Referentienummer 5',
    EXTRACTED_FIELDS_Name1: 'Naam 1',
    EXTRACTED_FIELDS_Name2: 'Naam 2',
    EXTRACTED_FIELDS_Name3: 'Naam 3',
    EXTRACTED_FIELDS_Name4: 'Naam 4',
    EXTRACTED_FIELDS_Name5: 'Naam 5',
    EXTRACTED_FIELDS_RECIPIENT_NAME_1: 'Naam ontvanger 1',
    EXTRACTED_FIELDS_RECIPIENT_NAME_2: 'Naam ontvanger 2',
    EXTRACTED_FIELDS_RECIPIENT_NAME_3: 'Naam ontvanger 3',
    EXTRACTED_FIELDS_RECIPIENT_NAME_4: 'Naam ontvanger 4',
    EXTRACTED_FIELDS_RECIPIENT_ADDRESS_FULL: 'Adres ontvanger Volledig',
    EXTRACTED_FIELDS_IBAN: 'IBAN Rekeningnummer',
    EXTRACTED_FIELDS_ACCOUNT_NUM: 'Rekeningnummer',
    EXTRACTED_FIELDS_ISSUER: 'Verstrekker',
    EXTRACTED_FIELDS_RECIPIENT_ADDRESS_CITY: 'Adres ontvanger Stad',
    EXTRACTED_FIELDS_RECIPIENT_ADDRESS_POST_CODE: 'Adres ontvanger Postcode',
    EXTRACTED_FIELDS_DAY: 'Dag',
    EXTRACTED_FIELDS_MONTH: 'Maand',
    EXTRACTED_FIELDS_YEAR: 'Jaar',
    EXTRACTED_FIELDS_OPTIONAL_VALUE_1: 'Optionele waarde 1',
    EXTRACTED_FIELDS_OPTIONAL_VALUE_2: 'Optionele waarde 2',
    EXTRACTED_FIELDS_OPTIONAL_VALUE_3: 'Optionele waarde 3',
    EXTRACTED_FIELDS_OPTIONAL_VALUE_4: 'Facultatieve waarde 4',
    EXTRACTED_FIELDS_ISSUING_STATE_NAME: 'Staat van afgifte Naam',
    EXTRACTED_FIELDS_FRONT_DOCUMENT_TYPE_ID: 'Id documenttype voorzijde',
    EXTRACTED_FIELDS_BACK_DOCUMENT_TYPE_ID: 'Id documenttype achterzijde',
    HASNOCAMERA_TITLE: 'Oeps, we konden geen camera herkennen op uw apparaat!',
    HASNOCAMERA_DESCRIPTION:
        'Het lijkt erop dat uw apparaat geen camera heeft. Probeer het opnieuw op een ander apparaat met een werkende camera, zodat u alle vereiste stappen kunt uitvoeren.',
    EXTRACTED_FIELDS_COVIDPASSCROSSCHECKRESULT: 'Covid Type Id',
    USER_INPUT_FIRST_NAME: 'Voornaam',
    USER_INPUT_MIDDLE_NAME: 'Tweede naam',
    USER_INPUT_LAST_NAME: 'Achternaam',
    USER_INPUT_DOB: 'Geboortedatum',
    USER_INPUT_HOUSE_NAME_NUMBER: 'Huisnaam/huisnummer*',
    USER_INPUT_STREET_NAME: 'Straatnaam*',
    USER_INPUT_TOWN: 'Stad*',
    USER_INPUT_POSTAL_CODE: 'Postcode*',
    USER_INPUT_HOUSE_NAME_NUMBER_EXAMPLE: 'bijv. huis/35',
    USER_INPUT_STREET_NAME_EXAMPLE: 'bijv. Teststraat',
    USER_INPUT_TOWN_EXAMPLE: 'bijv. Somewhere',
    USER_INPUT_POSTAL_CODE_EXAMPLE: 'bijv. CH496 (geen spaties)',
    SYSTEM_NOT_ABLE: 'Het systeem kon het document niet scannen',
    TRY_AGAIN: 'Probeer het opnieuw',
    HINTS_DISABLED_HEADER: 'Hints zijn uitgeschakeld in de handmatige modus',
    HINTS_DISABLED_DESCRIPTION:
        'Als u de hints wilt inschakelen om een foto te maken, schakelt u over naar de modus AUTOMATISCHE OPNAME',
    YOU_HAVE: 'Je hebt',
    PICTURE_VERIFYING: 'Verifiëren...',
    HOW_TO_TAKE_PHOTO_CORRECTLY: 'Hoe maak je een foto van hoge kwaliteit',
};
